import { Typography, Link } from '@mui/material';
import * as XLSX from 'xlsx';

export const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  };
  
export const stringAvatar = (name) => {
  const nameParts = name.split(' ');
  const initials = nameParts.length > 1 
      ? `${nameParts[0][0]}${nameParts[1][0]}` 
      : `${nameParts[0][0]}`;
  
  return {
      sx: { bgcolor: stringToColor(name) },
      children: initials,
  };
};

export const CopyRight = () => {
  return (
    <Typography variant="body2" color="text.secondary" align="center" sx={{ pt: 4 }}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.drsongsquare.com/">
        Dr Song Square
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export const getFileExtension = (fileName) => {
  return fileName.split('.').pop();
}

export const exportToCSV = (data, teacherList, fileName = 'HomeworkList') => {
  const csvRows = [];

  const headers = ['Date', 'Subject', 'Teacher', 'Rating', 'Homework', 'Topic', 'Journal'];
  csvRows.push(headers.join(','));

  data.forEach(row => {
    const createdDate = new Date(row.createdDate.seconds * 1000).toISOString().split('T')[0]; // YYYY-MM-DD 형식

    csvRows.push([
      createdDate, 
      row.subject || '',
      teacherList.find(teacher => teacher.id === row.teacherUid)?.displayName || '',
      row.rating || 0,
      `"${row.homework}"`,
      `"${row.journal || ''}"`,
      `"${row.topic || ''}"`,
    ].join(','));
  });

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


export const exportToExcel = (data, teacherList, fileName = 'HomeworkList') => {
  const excelData = data.map(row => ({
    Date: new Date(row.createdDate.seconds * 1000).toISOString().split('T')[0], // YYYY-MM-DD
    Subject: row.subject || '',
    Teacher: teacherList.find(teacher => teacher.id === row.teacherUid)?.displayName || '',
    Rating: row.rating || '-',
    Homework: row.homework || '',
    Topic: row.topic || '',
    Journal: row.journal || '',
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'HomeworkList');

  const range = XLSX.utils.decode_range(worksheet['!ref']);
  for (let C = range.s.c; C <= range.e.c; C++) {
    const headerCell = XLSX.utils.encode_cell({ r: 0, c: C }); 
    if (!worksheet[headerCell]) continue; 
    worksheet[headerCell].s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } }, 
      fill: { fgColor: { rgb: '4CAF50' } }, 
      alignment: { horizontal: 'center', vertical: 'center' }, 
    };
  }

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const chunkArray = (arr, size) =>
  arr.length ? [arr.slice(0, size), ...chunkArray(arr.slice(size), size)] : [];
